export default "__VITE_ASSET__DKUSJWBt__"